import React, {FC} from 'react';
import {useAppSelector} from "../../shared/hooks/useAppSelector";
import {Navigate, Outlet} from "react-router-dom";
import FullPageLoader from "../../shared/components/full-page-loader/FullPageLoader";

interface PublicRouteProps {
  redirectTo?: string;
  children?: React.ReactElement;
}

const PublicRoute: FC<PublicRouteProps> = ({
                       redirectTo = '/students',
                       children
                     }) => {

  const {authChecked, authenticated} = useAppSelector(state => state.auth)

  if (!authChecked) {
    return <FullPageLoader/>
  }

  if (authenticated) {
    return <Navigate to={redirectTo} replace/>
  }

  return children ? children : <Outlet/>
};

export default PublicRoute;